import { render, staticRenderFns } from "./CopyToClipboardComponent.vue?vue&type=template&id=68986890&data-cy=copyToClipboardComponent&"
import script from "./CopyToClipboardComponent.vue?vue&type=script&lang=ts&"
export * from "./CopyToClipboardComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68986890')) {
      api.createRecord('68986890', component.options)
    } else {
      api.reload('68986890', component.options)
    }
    module.hot.accept("./CopyToClipboardComponent.vue?vue&type=template&id=68986890&data-cy=copyToClipboardComponent&", function () {
      api.rerender('68986890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CopyToClipboard/CopyToClipboardComponent.vue"
export default component.exports